// TODO: remove browser dependency: import { ErrorReport } from '../../../../lib/errorReports';
import { IVFSResponse } from '../types';
import BaseAPI from '../BaseAPI';
import { ErrorReport } from './types';

/**
 * Analytics API
 * Handles analytics-related operations
 */
class AnalyticsAPI extends BaseAPI {
  /**
   * Send an error report to the analytics service
   * @param payload - Error report data
   */
  async sendErrorReport(payload: ErrorReport): Promise<IVFSResponse<void>> {
    return this.wrapResponse<void>({
      promise: this.apiInstance.post('/v1/analytics/error', payload),
      errorMessage: 'Failed to send error report',
    });
  }
}

export default AnalyticsAPI;
